// extracted by mini-css-extract-plugin
module.exports = {"styleSelec":"styles_styleSelec__1woHZ"};